(function() {
	/**
	 * @exports DKA.controllers.roiCalculator
	 * @requires HBS
	 */
	let module = {};
	var assetPath = window.location.origin + '/wp-content/themes/switch-tech-theme/';

	var debug = false;
 
 	//Product lookup contains JSON structured data pulled from spreadsheet "Product Lookup" tab/table
	var productLookup = [];

	//Initial purchase is JSON structured data used to hold values stored and calculated from the "Initial Purchase" section of the spreadsheet
	var initialPurchase = [];

	//Global User Servicable Fields
	var fieldLostKeyResponsibility = jQuery('#input_5_1').val();
	var fieldNumberOfDoors = parseInt(jQuery('#input_5_3').val());
	var fieldCoreType = jQuery('#input_5_4').val();
	var fieldNumberOfKeysPerDoor = parseInt(jQuery('#input_5_5').val());
	var fieldEstimatedProductLifeSpan = parseInt(jQuery('#input_5_6').val());

	//Internal User Servicable Fields
	var fieldNumberOfLostKeysPerYearInternal = parseInt(jQuery('#input_5_54').val());
	var fieldNumberHoursAssociatedWithReplacementInternal = parseInt(jQuery('#input_5_7').val());
	var fieldWeightedLaborRateInternal = parseFloat(jQuery('#input_5_13').val());
	var fieldNumberOfRotationsPerYearInternal = parseInt(jQuery('#input_5_24').val());

	//Internal vars to store calculated results
	var ROIinternal;
	var lifeOfMechancialSystemSavingsInternal;
	var totalCostMaintainingKeySystemInternal;

	//Outsourced User Servicable Fields
	var fieldNumberOfLostKeysPerYearOutsourced = parseInt(jQuery('#input_5_37').val());
	var fieldNumberHoursAssociatedWithReplacementOutsourced = parseInt(jQuery('#input_5_32').val());
	var fieldWeightedLaborRateOutsourced = parseFloat(jQuery('#input_5_36').val());
	var fieldNumberOfRotationsPerYearOutsourced = parseInt(jQuery('#input_5_47').val());

	//Outsourced vars to store calculated results
	var ROIoutsourced;
	var lifeOfMechancialSystemSavingsOutsourced;
	var totalCostMaintainingKeySystemOutsourced;

	//Final storage fields for selected internal/outsourced calculations
	var finalTotalCostMaintainingKeySystem = jQuery('#input_5_60');
	var finalROI = jQuery('#input_5_61');
	var finalLifeOfMechanicalSystemSavings = jQuery('#input_5_62');

	module.init = () => {
		module.getProductLookupData();
		module.setupChangeHandlers();
		module.showHideInternalOutsourcedFields();
		module.setupAccountingOptions();

		jQuery(document).on('gform_post_render', function(event, form_id, current_page){
	       	module.validateSubmitButton();
			module.inputChangeValidator();
	    });

		module.validateSubmitButton();
		module.inputChangeValidator();

		//Remove query params on page load
		//setTimeout(function(){
		//	window.history.replaceState({}, document.title, location.protocol + '//' + location.host + location.pathname);
		//}, 4000);

		module.showHideInternalOutsourcedFieldsHelper();
		module.enableDisableFormSubmit();
	};


	//Sets options for accounting.js, used to format numbers in various ways
	module.setupAccountingOptions = function() {
		accounting.settings.currency.format = {
			pos : "%s%v",   // for positive values, eg. "$ 1.00" (required)
			neg : "%s(%v)", // for negative values, eg. "$ (1.00)" [optional]
			zero: "%s-- "  // for zero values, eg. "$  --" [optional]
		};
	}

	//Handles showing/hiding internal & outsourced fields based on the the selection in the drop down
	module.showHideInternalOutsourcedFields = function() {
		jQuery('#input_5_1').on('change', function(){
			module.showHideInternalOutsourcedFieldsHelper();
			module.enableDisableFormSubmit();
		});
	};


	module.showHideInternalOutsourcedFieldsHelper = function() {
		if ( jQuery('#input_5_1').val() === "An internal team member") {
			//Hide Outsourced Fields
			jQuery('#field_5_47, #field_5_37').addClass('d-none');

			//Show Internal Fields
			jQuery('#field_5_7, #field_5_54, #field_5_24').removeClass('d-none');
		} else {
			//Show Outsourced Fields
			jQuery('#field_5_47, #field_5_37').removeClass('d-none');

			//Hide Internal Fields
			jQuery('#field_5_7, #field_5_54, #field_5_24').addClass('d-none');
		}
	};

	//Gets product lookup and initial purchase data via AJAX, json files stored in assets/references
	module.getProductLookupData = function() {
		jQuery.getJSON(assetPath + 'dist/js/DKA/calculatordata/productlookup.json').done(function(data) {
			productLookup = data;

			jQuery.getJSON(assetPath + 'dist/js/DKA/calculatordata/initialpurchase.json').done(function(data) {
				initialPurchase = data;
				module.calculateInitialPurchaseData(productLookup, initialPurchase);
			}).fail(function(e) {
			    console.log('Error fetching initial purchase data: ' + e.statusText);
			  });
		}).fail(function(e) {
		    console.log('Error fetching product lookup data: ' + e.statusText);
		});
	};

	//Main calculation method, handles all the maths
	//Accepts:
	//- productLookup: json
	//- initialPurchase: json
	module.calculateInitialPurchaseData = function(productLookup, initialPurchase) {

		fieldLostKeyResponsibility = jQuery('#input_5_1').val();
        fieldNumberOfDoors = parseInt(jQuery('#input_5_3').val());
        fieldCoreType = jQuery('#input_5_4').val();
        fieldNumberOfKeysPerDoor = parseInt(jQuery('#input_5_5').val());
        fieldEstimatedProductLifeSpan = parseInt(jQuery('#input_5_6').val());

        //Get current values from user servicable internal fields
        fieldNumberOfLostKeysPerYearInternal = parseInt(jQuery('#input_5_54').val());
		fieldNumberHoursAssociatedWithReplacementInternal = parseInt(jQuery('#input_5_7').val());
		fieldNumberOfRotationsPerYearInternal = parseInt(jQuery('#input_5_24').val());

        //Get current values from user servicable outsource fields
        fieldNumberOfLostKeysPerYearOutsourced = parseInt(jQuery('#input_5_37').val());
		fieldNumberOfRotationsPerYearOutsourced = parseInt(jQuery('#input_5_47').val());

		// ---------------------------------------
		//INITIAL PURCHASE - MECHANICAL
		var initialPurchaseMechanical = initialPurchase[0].mechanical; //mechanical object of initialpurchase.json
		
		//Update core values
		var searchCoreValues = module.searchData(productLookup, fieldCoreType + ' Core');

		//Update core: {} object props
		initialPurchaseMechanical.core.partNumber = searchCoreValues[0].partNumber;
		initialPurchaseMechanical.core.msrp = searchCoreValues[0].msrp;
		initialPurchaseMechanical.core.total = (searchCoreValues[0].msrp * fieldNumberOfDoors).toFixed(2);

		//Update key values
		var searchKeyValues = module.searchData(productLookup, fieldCoreType + ' Key');

		//Update key: {} object props
		initialPurchaseMechanical.key.partNumber = searchKeyValues[0].partNumber;
		initialPurchaseMechanical.key.msrp = searchKeyValues[0].msrp;
		initialPurchaseMechanical.key.total = ( searchKeyValues[0].msrp * (fieldNumberOfDoors * fieldNumberOfKeysPerDoor) ).toFixed(2);

		//Update totalInitialPurchaseMechanical: prop
		initialPurchaseMechanical.totalInitialPurchaseMechanical = (parseFloat(initialPurchaseMechanical.core.total) + parseFloat(initialPurchaseMechanical.key.total)).toString();

		// ---------------------------------------
		//INITIAL PURCHASE - SWITCHTECH
		var initialPurchaseSwitchtech = initialPurchase[0].switchtech; //switchtech object of initialpurchase.json

		//Update core total
		initialPurchaseSwitchtech.core.total = (initialPurchaseSwitchtech.core.msrp * fieldNumberOfDoors).toFixed(2);

		//Update credential total
		initialPurchaseSwitchtech.credential.total = (initialPurchaseSwitchtech.credential.msrp * (fieldNumberOfDoors * fieldNumberOfKeysPerDoor)).toFixed(2);

		//Update totalInitialPurchaseSwitchTech: pro
		initialPurchaseSwitchtech.totalInitialPurchaseSwitchTech = (parseFloat(initialPurchaseSwitchtech.core.total) + parseFloat(initialPurchaseSwitchtech.credential.total)).toString();

		//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
		//CRITICAL UPDATE REQUIRED!!!
		//NOTE MIKE: 138600.00 needs replaced with calculated value from cell B:41
		initialPurchaseSwitchtech.roiWithoutCredentialRecurrence = ((initialPurchaseSwitchtech.totalInitialPurchaseSwitchTech - initialPurchaseMechanical.totalInitialPurchaseMechanical) / module.calculateb41()).toFixed(4);

		//Calculate initialPurchaseSwitchtech.recurringCostForCredential prop value
		var recurringCostForCredential;
		if ( initialPurchaseSwitchtech.roiWithoutCredentialRecurrence > 1 ) 
		{ 
			recurringCostForCredential = (Math.ceil(initialPurchaseSwitchtech.roiWithoutCredentialRecurrence) * initialPurchaseSwitchtech.credential.total).toString();
		} else { 
			recurringCostForCredential = "0" 
		}

		initialPurchaseSwitchtech.recurringCostForCredential = recurringCostForCredential;

		//Calculate ROI - Internal
		module.calculateb44();

		//Calculate ROI - Outsourced
		module.calculateg44();

		//Set final calculation fields
		module.setFinalCalculationFields();


		if (debug) {
			module.displayDebugInfo();
		}

	};

	//Helper method for searching objects when property key matches it returns the object
	//Accepts:
	//- productLookup: json data
	//- searchStr: search string
	module.searchData = function(productLookup, searchStr) {
		return productLookup.filter(obj => Object.keys(obj).some(key => obj[key].includes(searchStr)));
	};

	module.setupChangeHandlers = function() {

		//Lost Key Responsibility
		jQuery('#input_5_1').on('change', function(){
			module.calculateInitialPurchaseData(productLookup, initialPurchase);
		});

		//Number of Doors
		jQuery('#input_5_3').on('keyup', function(){
			module.calculateInitialPurchaseData(productLookup, initialPurchase);

			module.restrictInputsToNumberedRange(this, '', 1000);
		});

		//Core Type
		jQuery('#input_5_4').on('change', function(){
			module.calculateInitialPurchaseData(productLookup, initialPurchase);
		});

		//Number of Keys per Door
		jQuery('#input_5_5').on('keyup', function(){
			module.calculateInitialPurchaseData(productLookup, initialPurchase);

			module.restrictInputsToNumberedRange(this, '', 100);
		});

		//Estimated product life span
		jQuery('#input_5_6').on('keyup', function(){
			module.calculateInitialPurchaseData(productLookup, initialPurchase);

			module.restrictInputsToNumberedRange(this, '', 20);
		});


		// === INTERNAL FIELDS ===

		//Hours associated with replacement
		jQuery('#input_5_7').on('keyup', function(){
			module.calculateInitialPurchaseData(productLookup, initialPurchase);

			module.restrictInputsToNumberedRange(this, '', 10);
		});

		//Number of lost keys per year
		jQuery('#input_5_54').on('keyup', function(){
			module.calculateInitialPurchaseData(productLookup, initialPurchase);

			module.restrictInputsToNumberedRange(this, '', 1000);
		});

		//Number of rotations per year
		jQuery('#input_5_24').on('keyup', function(){
			module.calculateInitialPurchaseData(productLookup, initialPurchase);
		});

		// === OUTSOURCED FIELDS ===

		//Number of lost keys per year
		jQuery('#input_5_37').on('keyup', function(){
			module.calculateInitialPurchaseData(productLookup, initialPurchase);

			module.restrictInputsToNumberedRange(this, '', 1000);
		});

		//Number of rotations per year
		jQuery('#input_5_47').on('keyup', function(){
			module.calculateInitialPurchaseData(productLookup, initialPurchase);
		});
	};

	//*************************************************************************************
	// --------------------------- Internal Calculation Methods ---------------------------
	//*************************************************************************************

	//Calculates Material Cost Per Door - Internal (Lost Key)
	module.calculateb19 = function() {
		var b20 = parseFloat(initialPurchase[0].mechanical.core.msrp); //Material Cost Per Door - Core
		var b21 = parseFloat(initialPurchase[0].mechanical.key.msrp); //Material Cost Per door - Key
		var b19 = b20 + (b21 * fieldNumberOfKeysPerDoor); //Material Cost Per Door

		return b19;
	};

	//Calculates Labor Cost - Internal (Lost Key)
	module.calculateb25 = function() {
		var b25 = fieldNumberOfLostKeysPerYearInternal * fieldNumberHoursAssociatedWithReplacementInternal * fieldWeightedLaborRateInternal;

		return b25;
	};

	//Calculates Material Cost - Internal (Lost Key)
	module.calculateb26 = function() {
		var b26 = module.calculateb19() * fieldNumberOfLostKeysPerYearInternal;
		
		return b26;
	};

	//Calculates Sub Total - Internal (Lost Key)
	module.calculateb27 = function() {
		var b27 = module.calculateb25() + module.calculateb26();

		return b27;
	};

	//Calculates Hours Associated with Replacement - Internal (Core Rotation)
	module.calculateb30 = function() {
		var b30 = (15 * fieldNumberOfDoors) / 60;

		return b30;
	};

	//Calculates Material Cost Per Door - Internal (Core Rotation)
	module.calculateb31 = function() {
		var b32 = parseFloat(initialPurchase[0].mechanical.core.msrp);
		var b33 = parseFloat(initialPurchase[0].mechanical.key.msrp);

		var b31 = b32 + (b33 * fieldNumberOfKeysPerDoor);

		return b31;
	};

	//Calculates Labor Cost - Internal (Core Rotation)
	module.calculateb37 = function() {
		var b37 = fieldNumberOfRotationsPerYearInternal * module.calculateb30() * parseFloat(jQuery('#input_5_23').val());
		
		return b37;
	};

	//Calculates Material Cost - Internal (Core Rotation)
	module.calculateb38 = function() {
		var b38;
		if ( fieldNumberOfRotationsPerYearInternal > 0 ) {
			b38 = module.calculateb31() * fieldNumberOfDoors;
		} else {
			b38 = 0;
		}

		return b38;
	};

	//Calculates Sub Total - Internal (Core Rotation)
	module.calculateb39 = function() {
		var b39 = module.calculateb37() + module.calculateb38();

		return b39;
	};

	//Calculates Total Cost maintaining Key System - Internal
	module.calculateb41 = function() {
		var b41 = module.calculateb27() + module.calculateb39();

		totalCostMaintainingKeySystemInternal = b41;

		return b41;
	};

	//Calculates ROI - Internal
	module.calculateb44 = function() {
		var b44;
		var initialPurchaseSwitchTech = initialPurchase[0].switchtech;
		var initialPurchaseMechanical = initialPurchase[0].mechanical;

		if ( initialPurchaseSwitchTech.roiWithoutCredentialRecurrence <= 1 ) {
			b44 = (parseFloat(initialPurchaseSwitchTech.totalInitialPurchaseSwitchTech) - parseFloat(initialPurchaseMechanical.totalInitialPurchaseMechanical)) / module.calculateb41();
		} else {
			b44 = ((parseFloat(initialPurchaseSwitchTech.totalInitialPurchaseSwitchTech) - parseFloat(initialPurchaseMechanical.totalInitialPurchaseMechanical)) + parseFloat(initialPurchaseSwitchTech.recurringCostForCredential)) / module.calculateb41();
		}

		//Update variable
		ROIinternal = b44.toFixed(1);

		//Set value of hidden field
		jQuery('#input_5_29').val(b44);

		module.calculatec44();
	};


	//Calculates Life of Mechanical System Savings - Internal
	module.calculatec44 = function() {
		var c44 = (fieldEstimatedProductLifeSpan - ROIinternal) * module.calculateb41();

		//Update variable
		lifeOfMechancialSystemSavingsInternal = c44;

		//Set value of hidden field
		jQuery('#input_5_30').val(c44);
	};


	//*************************************************************************************
	// -------------------------- Outsourced Calculation Methods --------------------------
	//*************************************************************************************

	//Calculates Material Cost Per Door - Outsourced (Lost Key)
	module.calculateg19 = function() {
		var g20 = parseFloat(initialPurchase[0].mechanical.core.msrp); //Material Cost Per Door - Core
		var g21 = parseFloat(initialPurchase[0].mechanical.key.msrp); //Material Cost Per door - Key
		var g19 = g20 + (g21 * fieldNumberOfKeysPerDoor); //Material Cost Per Door

		return g19;
	};

	//Calculates Labor Cost - Outsourced (Lost Key)
	module.calculateg25 = function() {
		var g25 = fieldNumberOfLostKeysPerYearOutsourced * fieldNumberHoursAssociatedWithReplacementOutsourced * fieldWeightedLaborRateOutsourced;

		return g25;
	};

	//Calculates Material Cost - Internal (Lost Key)
	module.calculateg26 = function() {
		var g26 = module.calculateg19() * fieldNumberOfLostKeysPerYearOutsourced;

		return g26;
	};

	//Calculates Sub Total - Outsourced (Lost Key)
	module.calculateg27 = function() {
		var g27 = module.calculateg25() + module.calculateg26();

		return g27;
	};

	//Calculates Hours Associated with Replacement - Outsourced (Core Rotation)
	module.calculateg30 = function() {
		var g30 = (15 * fieldNumberOfDoors) / 60;

		return g30;
	};

	//Calculates Material Cost Per Door - Outsourced (Core Rotation)
	module.calculateg31 = function() {
		var g32 = parseFloat(initialPurchase[0].mechanical.core.msrp);
		var g33 = parseFloat(initialPurchase[0].mechanical.key.msrp);

		var g31 = g32 + (g33 * fieldNumberOfKeysPerDoor);

		return g31;
	};

	//Calculates Labor Cost - Outsourced (Core Rotation)
	module.calculateg37 = function() {
		var g37 = fieldNumberOfRotationsPerYearOutsourced * module.calculateg30() * fieldWeightedLaborRateOutsourced;
		
		return g37;
	};

	//Calculates Material Cost - Outsourced (Core Rotation)
	module.calculateg38 = function() {
		var g38;
		if ( fieldNumberOfRotationsPerYearOutsourced > 0 ) {
			g38 = module.calculateg31() * fieldNumberOfDoors;
		} else {
			g38 = 0;
		}

		return g38;
	};


	//Calculates Sub Total - Outsourced (Core Rotation)
	module.calculateg39 = function() {
		var g39 = module.calculateg37() + module.calculateg38();

		return g39;
	};

	//Calculates Total Cost maintaining Key System - Outsourced
	module.calculateg41 = function() {
		var g41 = module.calculateg27() + module.calculateb39();

		totalCostMaintainingKeySystemOutsourced = g41;

		return g41;
	};


	//Calculates ROI - Outsourced
	module.calculateg44 = function() {
		var g44;
		var initialPurchaseSwitchTech = initialPurchase[0].switchtech;
		var initialPurchaseMechanical = initialPurchase[0].mechanical;

		if ( initialPurchaseSwitchTech.roiWithoutCredentialRecurrence <= 1 ) {
			g44 = (parseFloat(initialPurchaseSwitchTech.totalInitialPurchaseSwitchTech) - parseFloat(initialPurchaseMechanical.totalInitialPurchaseMechanical)) / module.calculateg41();
		} else {
			g44 = ((parseFloat(initialPurchaseSwitchTech.totalInitialPurchaseSwitchTech) - parseFloat(initialPurchaseMechanical.totalInitialPurchaseMechanical)) + parseFloat(initialPurchaseSwitchTech.recurringCostForCredential)) / module.calculateg41();
		}

		//Update variable
		ROIoutsourced = g44.toFixed(1);

		//Set value of hidden field
		jQuery('#input_5_52').val(g44);

		module.calculateh44();
	};

	//Calculates Life of Mechanical System Savings - Outsourced
	module.calculateh44 = function() {
		var h44 = (fieldEstimatedProductLifeSpan - ROIoutsourced) * module.calculateg41();

		//Update variable
		lifeOfMechancialSystemSavingsOutsourced = h44;

		//Set value of hidden field
		jQuery('#input_5_53').val(h44);
	};

	//Sets the values of hidden fields used to display final calculated results to user
	module.setFinalCalculationFields = function() {
		if ( fieldLostKeyResponsibility === "An internal team member") {
			finalTotalCostMaintainingKeySystem.val(accounting.formatMoney(totalCostMaintainingKeySystemInternal));
			finalROI.val(ROIinternal);
			finalLifeOfMechanicalSystemSavings.val(accounting.formatMoney(Math.round(lifeOfMechancialSystemSavingsInternal/100)*100));
		} else {
			finalTotalCostMaintainingKeySystem.val(accounting.formatMoney(totalCostMaintainingKeySystemOutsourced));
			finalROI.val(ROIoutsourced);
			finalLifeOfMechanicalSystemSavings.val(accounting.formatMoney(Math.round(lifeOfMechancialSystemSavingsOutsourced/100)*100));
		}
	};

	module.validateSubmitButton = function() {
		var submitButton = jQuery('#gform_submit_button_5');
		submitButton.on('click', function(e){
			if (submitButton.hasClass('disabled') ) {
				e.preventDefault();
			}
		});
	};

	module.validateForm = function() {
		var isValid = true;
		jQuery('.gfield.validate:visible input').each(function() {
			if ( jQuery(this).val() === '' )
			isValid = false;
		});

		return isValid;
	};

	module.inputChangeValidator = function() {
		jQuery('.gfield.validate input').on('keyup', function(){
			module.enableDisableFormSubmit();
		});
	};

	module.enableDisableFormSubmit = function() {
		var submitButton = jQuery('#gform_submit_button_5');
		if ( module.validateForm() == true ) {
			submitButton.removeClass('disabled');
		} else {
			submitButton.addClass('disabled');
		}
	};

	module.restrictInputsToNumberedRange = function(input, min, max) {
		input.value = input.value.replace(/[^0-9\.]/g,'');

		if (input.value == 0 && input.value.length == 1) {
			input.value = min;
		} 

		if ( input.value > max ) {
			input.value = max;
		}
	};

	//Debug helper, will console.log all final calculated results
	module.displayDebugInfo = function() {
		console.log('========== INTERNAL RESULTS ===========');
		console.log('Total Cost Maintaining Key System: ' + accounting.formatMoney(totalCostMaintainingKeySystemInternal));
		console.log('ROI: ' + ROIinternal);
		console.log('Life of Mechanical System Savings: ' + accounting.formatMoney(Math.round(lifeOfMechancialSystemSavingsInternal/100)*100));

		console.log('========== OUTSOURCED RESULTS ===========');
		console.log('Total Cost Maintaining Key System: ' + accounting.formatMoney(totalCostMaintainingKeySystemOutsourced));
		console.log('ROI: ' + ROIoutsourced);
		console.log('Life of Mechanical System Savings: ' + accounting.formatMoney(Math.round(lifeOfMechancialSystemSavingsOutsourced/100)*100));

		console.log('========== INITIAL PURCHASE CALCULATED RESULTS ===========');
		console.log(initialPurchase);
	};


	HBS.namespace('DKA.controllers.roiCalculator', module);
}());